"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOLIDITY_TYPE_MAXIMA = exports.SolidityType = exports._1000 = exports._997 = exports._100 = exports.TEN = exports.FIVE = exports.THREE = exports.TWO = exports.ONE = exports.ZERO = exports.MINIMUM_LIQUIDITY = exports.Rounding = exports.TradeType = exports.ChainId = void 0;
const tslib_1 = require("tslib");
const jsbi_1 = tslib_1.__importDefault(require("jsbi"));
var ChainId;
(function (ChainId) {
  ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
  ChainId[ChainId["ROPSTEN"] = 3] = "ROPSTEN";
  ChainId[ChainId["RINKEBY"] = 4] = "RINKEBY";
  ChainId[ChainId["GOERLI"] = 5] = "GOERLI";
  ChainId[ChainId["KOVAN"] = 42] = "KOVAN";
  ChainId[ChainId["BSCMAIN"] = 56] = "BSCMAIN";
  ChainId[ChainId["BSCTEST"] = 97] = "BSCTEST";
  ChainId[ChainId["POLYGON_MAINNET"] = 137] = "POLYGON_MAINNET";
  ChainId[ChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
  ChainId[ChainId["AVALANCHE"] = 43114] = "AVALANCHE";
  ChainId[ChainId["AVALANCHE_FUJI"] = 43113] = "AVALANCHE_FUJI";
  ChainId[ChainId["APEX"] = 1501795822] = "APEX";
  ChainId[ChainId["ARBITRUM"] = 42161] = "ARBITRUM";
  ChainId[ChainId["ZKSYNC"] = 324] = "ZKSYNC";
  ChainId[ChainId["ZKSYNCTEST"] = 280] = "ZKSYNCTEST";
  ChainId[ChainId["OPTIMISM"] = 10] = "OPTIMISM";
  ChainId[ChainId["LINEA"] = 59144] = "LINEA";
  ChainId[ChainId["BASE"] = 8453] = "BASE";
  ChainId[ChainId["DEFI"] = 1130] = "DEFI";
  ChainId[ChainId["ROOTSTOCK"] = 30] = "ROOTSTOCK";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
var TradeType;
(function (TradeType) {
  TradeType[TradeType["EXACT_INPUT"] = 0] = "EXACT_INPUT";
  TradeType[TradeType["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
})(TradeType = exports.TradeType || (exports.TradeType = {}));
var Rounding;
(function (Rounding) {
  Rounding[Rounding["ROUND_DOWN"] = 0] = "ROUND_DOWN";
  Rounding[Rounding["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
  Rounding[Rounding["ROUND_UP"] = 2] = "ROUND_UP";
})(Rounding = exports.Rounding || (exports.Rounding = {}));
exports.MINIMUM_LIQUIDITY = jsbi_1.default.BigInt(1000);
// exports for internal consumption
exports.ZERO = jsbi_1.default.BigInt(0);
exports.ONE = jsbi_1.default.BigInt(1);
exports.TWO = jsbi_1.default.BigInt(2);
exports.THREE = jsbi_1.default.BigInt(3);
exports.FIVE = jsbi_1.default.BigInt(5);
exports.TEN = jsbi_1.default.BigInt(10);
exports._100 = jsbi_1.default.BigInt(100);
exports._997 = jsbi_1.default.BigInt(997);
exports._1000 = jsbi_1.default.BigInt(1000);
var SolidityType;
(function (SolidityType) {
  SolidityType["uint8"] = "uint8";
  SolidityType["uint256"] = "uint256";
})(SolidityType = exports.SolidityType || (exports.SolidityType = {}));
exports.SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: jsbi_1.default.BigInt('0xff'),
  [SolidityType.uint256]: jsbi_1.default.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
};
